/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360BusinessLogicRetailersStoresBEStore {
    Name: string;
    Description?: string;
    AddressLine1: string;
    AddressLine2?: string;
    Town: string;
    County: string;
    WebsiteUrl?: string;
    ContactEmail?: string;
    ContactPhoneNumber?: string;
    PostCode: string;
    Latitude: number;
    Longitude: number;
    /**
     * 1 = Shop, 2 = ShoppingCentre, 3 = Restaurant, 4 = Attraction, 5 = Accommodation, 6 = Education, 7 = Exhibition, 8 = Exhibitor
     */
    BusinessType?: Open360BusinessLogicRetailersStoresBEStore.BusinessTypeEnum;
    Menu?: string;
    BookingTableEnabled?: boolean;
    LoyaltyProgramID?: number;
    ExhibitionStartDate?: Date;
    ExhibitionEndDate?: Date;
}
export namespace Open360BusinessLogicRetailersStoresBEStore {
    export type BusinessTypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
    export const BusinessTypeEnum = {
        NUMBER_1: 1 as BusinessTypeEnum,
        NUMBER_2: 2 as BusinessTypeEnum,
        FoodAndDrink: 3 as BusinessTypeEnum,
        NUMBER_4: 4 as BusinessTypeEnum,
        NUMBER_5: 5 as BusinessTypeEnum,
        NUMBER_6: 6 as BusinessTypeEnum,
        NUMBER_7: 7 as BusinessTypeEnum,
        NUMBER_8: 8 as BusinessTypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersStoresBEStore.ts